(function () {
    'use strict';

    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var href = anchor.getAttribute('href');
            if (href === '#') return;

            e.preventDefault();
            var target = document.querySelector(href);
            if (target && window.apollonLenis) {
                window.apollonLenis.scrollTo(target, {
                    offset: -80,
                    duration: 1.5,
                });
            }
        });
    });
})();
